/**
 * Meta Pixel Service Interface
 *
 * Defines the contract for Meta Pixel (Facebook Pixel) integration.
 * Used for conversion tracking and analytics.
 */
export abstract class PixelService {
  /**
   * Track a conversion event
   * @param eventName - The name of the conversion event (e.g., 'Search', 'Purchase')
   * @param params - Optional event parameters
   */
  abstract trackConversion(eventName: string, params?: Record<string, unknown>): Promise<void>;

  /**
   * Track a custom event
   * @param eventName - The name of the custom event
   * @param params - Optional event parameters
   */
  abstract trackEvent(eventName: string, params?: Record<string, unknown>): Promise<void>;

  /**
   * Track a page view
   * @param path - The page path
   */
  abstract pageView(path: string): Promise<void>;
}
